module.exports = __webpack_public_path__ + "img/check-square-solid.9f123381.svg";